/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _region = _interopRequireDefault(require("../../../packages/region"));
var _default = function _default(cells, getIndex) {
  return (cells || []).map(function (c, i) {
    var node = c.domRef ? c.domRef.current : c.getDOMNode ? c.getDOMNode() : null;
    var reg = _region.default.from(node);
    var isCell = typeof c.getProps === 'function';
    var props = isCell ? c.getProps() : c.props;
    var result = {
      left: reg.left,
      right: reg.right,
      width: reg.width,
      computedLocked: props.computedLocked,
      index: getIndex === undefined ? i : getIndex(i, c, props)
    };
    return result;
  });
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/HeaderLayout/getRangesForBoxes.js
// module id = 565
// module chunks = 0